module.exports = __webpack_public_path__ + "images/Vitual-Labs.f350b3da.webp";